import React from 'react';
import { useModulesContext } from '../services/providers/ModulesProvider';
import ExternalPageLoader from './ExternalPageLoader';

interface IFilteredModulesProps {
  componentName: string;
  componentPage?: string;
  children?: React.ReactNode;
  props?: any;
}

const FilteredModules = ({
  componentName,
  componentPage,
  children,
  props = {}
}: IFilteredModulesProps) => {
  const modules = useModulesContext();

  const filteredModules = modules
    .filter((module) => {
      const positionMatch = Array.isArray(module.componentPosition)
        ? module.componentPosition.includes(componentName)
        : module.componentPosition === componentName;

      if (!positionMatch) return false;
      if (module.hideWhenLogged && Boolean(props?.isLogged)) return false;
      if (module.showWhenLogged && !Boolean(props?.isLogged)) return false;

      if (componentPage) {
        return module.componentPage === componentPage;
      }

      return !module.componentPage;
    })
    .sort((a, b) => a.componentOrder - b.componentOrder);

  // Se não há módulos filtrados, sempre renderiza o children
  if (filteredModules.length === 0) {
    return <>{children}</>;
  }

  return (
    <>
      {filteredModules.map((moduleData, index) => {
        // Mescla as props do JSON com as props passadas como parâmetro
        // As props passadas como parâmetro têm prioridade
        const mergedProps = {
          ...(moduleData.props || {}),
          ...props
        };

        return (
          <ExternalPageLoader
            key={`${moduleData.id}-${moduleData.componentPath}-${moduleData.componentOrder}-${index}`}
            moduleUrl={moduleData.moduleUrl}
            containerName={moduleData.containerName}
            componentPath={moduleData.componentPath}
            props={mergedProps}
          >
            {children}
          </ExternalPageLoader>
        );
      })}
    </>
  );
};

export default FilteredModules;
